export default __webpack_public_path__ + "static/media/ic_info.35d2b7a2.svg";